// components/WhyChooseUs.jsx
import React, { useState } from 'react';
import '../assets/css/WhyChooseUs.css';
import ConsultationScheduling from './ConsultationScheduling';

const WhyChooseUs = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  const advantages = [
    {
      title: "Managed Solution",
      description: "We recruit, vet, and manage your VA",
      icon: "👥"
    },
    {
      title: "Cost Savings",
      description: "Up to 70% cheaper than local hires",
      icon: "💰"
    },
    {
      title: "Reliability",
      description: "Weekly performance reports & guaranteed replacements",
      icon: "🛡️"
    },
    {
      title: "Scalability",
      description: "Add more VAs as your business grows",
      icon: "📈"
    },
    {
      title: "Global Talent, Local Support",
      description: "Skilled Filipino professionals, managed by a Philippine-based corporation",
      icon: "🌏"
    }
  ];

  const openConsultationModal = () => {
    setShowConsultationModal(true);
  };

  const closeConsultationModal = () => {
    setShowConsultationModal(false);
  };

  return (
    <section id="why-us" className="why-choose-us">
      <div className="container">
        <div className="section-header">
          <h2>Why Choose BPD Online Corp?</h2>
          <p>Discover the advantages that set us apart in the virtual assistant industry</p>
        </div>
        
        <div className="advantages-grid">
          {advantages.map((advantage, index) => (
            <div key={index} className="advantage-card">
              <div className="advantage-icon">
                <span>{advantage.icon}</span>
              </div>
              <div className="advantage-content">
                <h3>{advantage.title}</h3>
                <p>{advantage.description}</p>
              </div>
              <div className="advantage-number">0{index + 1}</div>
            </div>
          ))}
        </div>
        
        <div className="cta-section">
          <button className="btn-primary" onClick={openConsultationModal}>
            Schedule a Consultation
          </button>
        </div>
      </div>

      {/* Consultation Scheduling Modal */}
      {showConsultationModal && (
        <div className="modal-overlay">
          <div className="modal-content consultation-modal">
            <div className="modal-header">
              <h3>Schedule a Consultation</h3>
              <button className="modal-close" onClick={closeConsultationModal}>×</button>
            </div>
            <div className="modal-body">
              <ConsultationScheduling onClose={closeConsultationModal} />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default WhyChooseUs;